function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    document.body.classList.remove('position-fixed');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMedia();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    console.log('innerMediaHit==>');
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    //mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      //console.log('hitform');
  //     var productTopReview = $('.product__title').next('.shopify-block.shopify-app-block').clone();
  // $('.pdp-price-block[data-pdp-price-block]').append(productTopReview);
    });
    setTimeout(() => {    
      let checkDiscount = Number($(document).find('.item-discount-percentage').attr('data-discount-percent')); //console.log("checkDiscount==>", checkDiscount);
      $(document).find('.price__badge-sale').text(checkDiscount+'%');
      let productDiscountLimit = Number($(document).find('#product-discount-percent-limit').attr('data-discount-limit'));// console.log("productDiscountLimit==>", productDiscountLimit)
      let productFinalSaleText = $(document).find('#product-discount-percent-limit').text();//console.log("productFinalSaleText==>", productFinalSaleText)
      if(checkDiscount > productDiscountLimit ) {
        $(document).find('.product-final-sale-notice-wrapper .product-final-sale-notice').text(productFinalSaleText);
        $(document).find('.product-final-sale-notice-wrapper input[name]').val('true');
      } else {
        $(document).find('.product-final-sale-notice-wrapper .product-final-sale-notice').text('');
        $(document).find('.product-final-sale-notice-wrapper input[name]').val('');
      }
    }, 1000);
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        console.log('currentVariantSku',this.currentVariant.sku )
        $('.product-variant-sku .sku-val').text(this.currentVariant.sku)
      });
      
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

window.addEventListener('DOMContentLoaded', (event) => {
  console.log('DOM fully loaded and parsed');  
  var productTopReview = $('.product__title').next('.shopify-block.shopify-app-block').detach();
  $('.pdp-price-block-wraper[data-pdp-price-block]').prepend(productTopReview);

  // var getPDPMainReviewBlock = setInterval(function(){
  //     if($('#shopify-product-reviews').length > 0){
  //       console.log('0');
  //       var productMainReview = $('#shopify-product-reviews').closest('.shopify-block.shopify-app-block').detach();
  //       $('.product__accordion > details[data-id="product-main-review-block"] .accordion__content[data-type="review"]').prepend(productMainReview);
  //       clearInterval(getPDPMainReviewBlock);
  //     }
  // },0)

  $('.jdgm-widget.jdgm-widget').on('click', function(){    
    
      console.log('Hit review');
    openReviewAccordion();

  //   $(document).find('.product__accordion details[data-id="product-main-review-block"]').attr('open', '');
  //   $(document).find('.product__accordion details[data-id="product-main-review-block"] summary').attr('aria-expanded', 'true');
  //   $('html, body').animate({
  //     scrollTop: $('details[data-id="product-main-review-block"]').offset().top - 100
  // }, 1000);
  })

  window.addEventListener("load", (event) => {
    // $(document).find('.product__accordion').each(function(){
    //   let detailsName = $(this).find('details').attr('data-cotnent'); console.log("detailsName==> ", detailsName)
    //   let contentLength = $(this).find('details[data-cotnent] .accordion__content').text().length; console.log("contentLength ==> ", contentLength)
    //   if(contentLength == 0) {
    //     $(this).hide();
    //   }
    // })
   
    if( $(document).find('.product__accordion details[data-cotnent="Specifications"] .accordion__content').text().length == 0){
      $(document).find('.product__accordion details[data-cotnent="Specifications"] ').closest('.product__accordion').hide()
    }
console.log("Fabric data ===>",$(document).find('.product__accordion details[data-cotnent*="Instruction de tissu et de soins"] .accordion__content').text().length)
    if($(document).find('.product__accordion details[data-cotnent="Fabric and Care Instructions"] .accordion__content').text().length == 0){
      $(document).find('.product__accordion details[data-cotnent="Fabric and Care Instructions"]').closest('.product__accordion').hide();      
    }

    if($(document).find('.product__accordion details[data-cotnent="Instruction de tissu et de soins"] .accordion__content').text().length == 0 ){      
      $(document).find('.product__accordion details[data-cotnent="Instruction de tissu et de soins"]').closest('.product__accordion').hide();
    }


    
    let hashVal = window.location.hash; console.log('===>',hashVal)
     if(hashVal != '' && hashVal == '#shopify-product-reviews'){
       console.log('test');
       // scrollToElement( $('.pdp-addition-info-section'), 600 );
       
       openReviewAccordion();
    //    var checkNewReviewCTA = setInterval(function(){
    //      console.log('0');
    //      if($(document).find('.jdgm-preview-badge').length > 0){       
    //       $('.product__accordion').find('details[data-id="product-main-review-block"]').attr('open', '');
    //       $('.product__accordion').find('details[data-id="product-main-review-block"] summary').attr('aria-expanded', 'true');
    //       $('html, body').animate({
    //         scrollTop: $('details[data-id="product-main-review-block"]').offset().top - 100
    //     }, 1000);                    
    //        clearInterval(checkNewReviewCTA);
    //      }  
    //    },0); 
      }
  });


  $.getJSON('/cart.js', function (cart, textStatus) {    
      updateCartPromo(cart);      
  });




$(document).on('click', '.featured__collection__block_header a', function(){
  $(this).addClass('active-slider').siblings('a').removeClass('active-slider');
  $(this).closest('.collection--full-width').find('.featured__collection_wrapper slider-component[data-id]').hide();
  $(this).closest('.collection--full-width').find('.featured__collection_wrapper slider-component[data-id="'+$(this).data('id')+'"]').show();

});
  
// Update image card-product image src on hover and click
  $(document).on('click, mouseenter', '.grid__item .card-information .product-form__input label',function(){
  var imgSrc = $(this).attr('data-variant');
  $(this).closest('.grid__item').find('.card__media img').attr({
    srcset:imgSrc,
    src:imgSrc,
    'data-srcset':imgSrc
  })
}) ; 

// quick view event
$(document).on('click', '[data-quickview]', function(){
  let prodHandle = $(this).data('handle');
  $.ajax({
    type: 'GET',
    url: '/products/'+prodHandle+'?view=quickview',
    success:function(data){
    //  console.log(data);
     
     $(document).find('#common-main-quickview-layout').html(data);
     $(document).find('#common-main-quickview-layout-overlay, #common-main-quickview-layout').addClass('show-quickview');
     $(document).find('#common-main-quickview-layout-overlay, #common-main-quickview-layout').css('transform', 'translateX(0%)')
     setTimeout(function(e){
      if($(document).find('[data-media-quickview-drawer]').attr('data-mediasize') > 1){
        if($(document).find('#common-main-quickview-layout .product-form__input.product-form__input-quickview.option-colors input:radio').length == 1) {
          $(document).find('#common-main-quickview-layout .product-form__input-quickview.option-colors label').addClass('pointer-event-none');
        }
        
        let selectedColor = $('#common-main-quickview-layout .product-form__input-quickview.option-colors input:checked').val();
        __updateGalleryQuickView(selectedColor, prodHandle)

      }else {
        $('.quickviewSlider').slick({
          infinite: false,
          adaptedHeight: false,
          arrows:true,
          dots: false
        });
      }
     
      let activeColor = $('.product-form__input-quickview.option-colors input:checked').val();
      let $thisContain = $('.product-form__input-quickview');
      let triggerFrom = 'quickView';
      if($('.product-form__input-quickview.option-colors').length > 0){
        hideColorOnLoadIfSizeNotAvailable(triggerFrom)
        variantSwatcher(activeColor, $thisContain, triggerFrom);
      }
     },)
     setTimeout(function(){
      $(document).find('#common-main-quickview-layout [data-media-quickview-drawer]').removeClass('enable-loader');
     },1000)
    }
  });
})
if($('body').attr('data-template') == "product"){
    let activeColor = $('.product-form__input-pdp.option-colors input:checked').val();
    let $thisContain = $('.product-form__input-pdp');
    let triggerFrom = 'mainPdp';
    if($('.product-form__input-pdp.option-colors').length > 0){
      hideColorOnLoadIfSizeNotAvailable(triggerFrom)
      variantSwatcher(activeColor, $thisContain, triggerFrom);
    }
    
}
// Close Quick view Drawer
$(document).on('click', '[data-close-quickview-drawer], #common-main-quickview-layout-overlay', function(){
  $(document).find('#common-main-quickview-layout-overlay, #common-main-quickview-layout').css('transform', 'translateX(100%)')
  setTimeout(function(){
    $(document).find('#common-main-quickview-layout-overlay, #common-main-quickview-layout').removeClass('show-quickview');
  },800)  
})

$(document).on('click', '.product-form__input-quickview label', function(){ 
  let $this = $(this);
  if($this.closest('.product-form__input-quickview').data('option') == '1'){ console.log('opt1 enter');
    var opt1 = $this.data('value');
    if($('.product-form__input-quickview[data-option="2"]').length > 0){
      var opt2 = $('.product-form__input-quickview[data-option="2"] input:radio:checked').val()
    }
    if($('.product-form__input-quickview[data-option="3"]').length > 0){
      var opt3 = $('.product-form__input-quickview[data-option="3"] input:radio:checked').val()
    }
  } else if($this.closest('.product-form__input-quickview').data('option') == '2'){
    var opt1 = $('.product-form__input-quickview[data-option="1"] input:radio:checked').val();
    var opt2 = $this.data('value');
    if($('.product-form__input-quickview[data-option="3"]').length > 0){
      var opt3 = $('.product-form__input-quickview[data-option="3"] input:radio:checked').val()
    }
  }else {
    var opt1 = $('.product-form__input-quickview[data-option="1"] input:radio:checked').val();
    var opt2 = $('.product-form__input-quickview[data-option="2"] input:radio:checked').val();
    var opt3 = $this.data('value');
  }
  console.log('eventhitt');
  let getSelectJson = $.parseJSON($(this).closest('.quickview-content-wrapper').find('[type="application/json"]').text());
  //console.log(getSelectJson);
  getSelectJson.forEach(function(v,i){
  //console.log(v);

if(v.option1 == ''+opt1+'' && v.option2 == ''+opt2+''){
  $('.quickview-content-wrapper form input[name="id"]').val(v.id);
}

 })
})

$(document).on('click', '.product-form__input-quickview.option-colors label, .product-form__input-pdp.option-colors label', function(){
  if($(this).closest('fieldset').hasClass('product-form__input-quickview')){
    var $thisContain = $('.product-form__input-quickview');
    var triggerFrom = 'quickView';
  }else{
    var $thisContain = $('.product-form__input-pdp')
    var triggerFrom = 'mainPdp';
  }
  var slectedColor = $(this).prev('input:radio').val(); console.log('slectedColor==>', slectedColor);
  //var selectedOpt = $(this).closest('.product-form__input-quickview').attr('data-option');
  variantSwatcher(slectedColor, $thisContain, triggerFrom);
 })

// update crossout soldout variant on color change
function variantSwatcher(activeColor, $thisContain, triggerFrom){
  if(triggerFrom == 'quickView'){
    $('.quickview-content-wrapper .selected-color-name').text(activeColor);
    var getSelectJson = $.parseJSON($('.quickview-content-wrapper').find('[type="application/json"]').text());
    $thisContain.find('input[name="Size"]').removeClass('crossedout');
  } else {
    var getSelectJson = $.parseJSON($('[data-pdp-content-wrapper]').find(' variant-radios [type="application/json"]').text());
    $thisContain.find('input[name="Size"]').removeClass('crossedout');
  }
  getSelectJson.filter((v) => {
    if(v.option1.includes(activeColor) && v.available == false ){
      console.log(v.id);
      $thisContain.find('input[name="Size"][value="'+v.option2+'"]').addClass('crossedout');
      $thisContain.find('input[name="Size"]').not('.crossedout').next('label').first().trigger('click');
    }   
    // $('.product-variant-sku .sku-val').text(v.sku);
  });
}

// Hide color if all sizes are soldout
function hideColorOnLoadIfSizeNotAvailable(triggerFrom){
  
  if(triggerFrom == 'quickView'){
    var getSizeLen = $('#shopify-section-main-quickview .product-form__input-quickview').not('.option-color').find('input[name="Size"]').length;
    var getSelectJsonOnLoad = $.parseJSON($('.quickview-content-wrapper').find('[type="application/json"]').text());
  } else {
    var getSizeLen = $('.product-form__input-pdp').not('.option-color').find('input[name="Size"]').length;
    var getSelectJsonOnLoad = $.parseJSON($('[data-pdp-content-wrapper]').find(' variant-radios [type="application/json"]').text());
  }
  console.log('ONLoadData', getSelectJsonOnLoad );
  const key = 'option1';

const arrayUniqueByKey = [...new Map(getSelectJsonOnLoad.map(item =>
  [item[key], item[key]])).values()];

// console.log(arrayUniqueByKey);

arrayUniqueByKey.forEach(function(itemVal){
  console.log("ItemValll==>", itemVal);
  var notAvailCounter = 0
  getSelectJsonOnLoad.filter((v, i) => {   
    console.log("opt1",v.option1,'======',v.available);
    if(v.option1.includes(itemVal) && v.available == false ){
      notAvailCounter = notAvailCounter+1;
      console.log(v.option1,'======',notAvailCounter,'======',getSizeLen);
      if(notAvailCounter == getSizeLen){
        if($('#shopify-section-main-quickview').is(':visible')){
          $('.product-form__input-quickview.option-colors label[data-value="'+v.option1+'"]').addClass('hide');
      }else{
        $('.product-form__input-pdp.option-colors label[data-value="'+v.option1+'"]').addClass('hide');
      }
       
      }     
    }   
  });
  
})

  
  
}


// Mega menu visibile on mousehover

$(document).on('click','.header__inline-menu .mega-menu', function(){
  let getTitle = $(this).closest('header-menu').find('details').attr('data-title'); console.log('GetTitle==> ', getTitle);
  $(document).find('.menu-drawer__submenu[data-target="'+getTitle+'"]').closest('.menu-drawer__menu.has-submenu').addClass('submenu-open');
  $(document).find('.menu-drawer__submenu[data-target="'+getTitle+'"]').closest('.menu-drawer__menu.has-submenu details').addClass('menu-opening').attr('open', 'open')
  $(document).find('.menu-drawer__submenu[data-target="'+getTitle+'"]').closest('.menu-drawer__menu.has-submenu details summary').attr('aria-expanded', 'true')
  $(this).closest('.header-wrapper').find('#Details-menu-drawer-container').addClass('menu-opening').attr('open', 'open');
  $('body').addClass('position-fixed');
  });

  $(document).on('click', '.menu-drawer__submenu[data-target] > .menu-drawer__inner-submenu ul summary.menu-drawer__menu-item', function(){
    $(document).find('header-drawer summary.header__icon').attr('data-level-enabled', '3');
  })

  $(document).on('click', '.menu-drawer__submenu[id^="childlink-"] button.menu-drawer__close-button, .header__icon.header__icon--menu', function(){
    $(document).find('header-drawer summary.header__icon').removeAttr('data-level-enabled');
  });
  
    $(document).on('click', '#shopify-section-main-quickview .product-form__buttons button.product-form__submit', function(){
      hideQuickViewModalWhenCartDrawerExist();
    })
    function hideQuickViewModalWhenCartDrawerExist(){
      var checkCartExist = setInterval(function(){
        if($('cart-drawer.active').length > 0){
          $('[data-close-quickview-drawer]').click();
          $.getJSON('/cart.js', function (cart, textStatus) {    
            updateCartPromo(cart)
        });
          clearInterval(checkCartExist);
        } else {
          setTimeout(function(){
            clearInterval(checkCartExist);
          },5000)
        }
      },0)
    }

    $(document).on('click', '[data-pdp-content-wrapper] .product-form__buttons button.product-form__submit', function(){
      var checkCartExist = setInterval(function(){
        if($('cart-drawer.active').length > 0){
          $.getJSON('/cart.js', function (cart, textStatus) {    
            updateCartPromo(cart)            
        });
          clearInterval(checkCartExist);
        } else {
          setTimeout(function(){
            clearInterval(checkCartExist);
          },5000)
        }
      },0)
      
    })


if($('.product-form__input.product-form__input-pdp.option-colors').length > 0 && $('[data-product-media-gallary-wrapper]').attr('data-gallarysize') > 1){
  if($('.product-form__input.product-form__input-pdp.option-colors input:radio').length == 1) {
    $('.product-form__input.product-form__input-pdp.option-colors label').addClass('pointer-event-none');
  }
  let DefaultSelectedColor = $('.product-form__input.product-form__input-pdp.option-colors input:checked').val();
  __updateGallery(DefaultSelectedColor);
}


// Function to update Gallary as per selected Variant color
$(document).on('click', '.product-form__input.product-form__input-pdp.option-colors label', function(){
  $('[data-product-media-gallary-wrapper]').addClass('enable-loader');
  let selectedColor = $(this).data('value');
  __updateGallery(selectedColor);
})

// Function to update quickView Gallary as per selected Variant color
$(document).on('click', '#common-main-quickview-layout .product-form__input.product-form__input-quickview.option-colors label', function(){
  $(document).find('#common-main-quickview-layout [data-media-quickview-drawer]').addClass('enable-loader');
  // $('[data-product-media-gallary-wrapper]').addClass('enable-loader');
  let selectedColor = $(this).data('value');
  let pHandle = $(this).closest('#common-main-quickview-layout').find('[data-media-quickview-drawer]').attr('data-handle')
  __updateGalleryQuickView(selectedColor, pHandle);
});


$('[data-main-pdp-slider]').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  asNavFor: '[data-main-pdp-thumb-slider]',
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$('[data-main-pdp-thumb-slider]').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '[data-main-pdp-slider]',
  dots: false,
  focusOnSelect: true,
  vertical: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


function __updateGallery(selectedColor){
  // alert('insert function');
  $('.selected-color-name').text(selectedColor);
  $(document).find('product-modal#ProductModal-main-product-gallary img.global-media-settings[data-media]').show();
  console.log("selectedColor==>", selectedColor)
  if(selectedColor.indexOf(' ') > -1){
    console.log('Insert-1');
    var colorOption1 = selectedColor.replaceAll('  ', '-').replaceAll(' ', '-').replaceAll('/', '').toLowerCase(); console.log("opt1=>",colorOption1)
    var colorOption2 = selectedColor.replaceAll('  ', '_').replaceAll(' ', '-').replaceAll('/', '').toLowerCase(); console.log("opt2=>",colorOption2)
    var colorOption3 = selectedColor.replaceAll('  ', '').replaceAll(' ', '').replaceAll('/', '').toLowerCase(); console.log("opt3=>",colorOption3)
    var colorOption4 = selectedColor.replace(' ', '-').replaceAll(' ', '').replaceAll('/', '').toLowerCase(); console.log("opt4=>",colorOption4)
    var colorOption5 = selectedColor.replaceAll(' ', '').replaceAll('/', '-').toLowerCase(); console.log("opt5=>",colorOption5)
  } else {
    console.log('Insert-2')
    var colorOption1 = selectedColor.replaceAll('/', '').toLowerCase(); console.log(colorOption1) 
  }
  
  dataurl = $('body').data('handle');
  $.ajax({
    url: '/products/'+dataurl+'?view=imagegallery',
    method: 'GET',
    success: function(res){
      if($(document).find('#shopify-section-main-product-gallary').length > 0 ){
        $(document).find('#shopify-section-main-product-gallary').remove();
      }
    //  console.log("res==>", res);
      $('[data-product-media-gallary-wrapper]').append(res);   
          if($('.product-form__input.product-form__input-pdp.option-colors input').length > 1){
            $(document).find('[data-gallary-thumb-slider] li, [data-gallary-featured-slider] li').not('[data-media*="'+colorOption1+'"], [data-media*="'+colorOption2+'"], [data-media*="'+colorOption3+'"], [data-media*="'+colorOption4+'"], [data-media*="'+colorOption5+'"]').remove();  
            $(document).find('product-modal#ProductModal-main-product-gallary img.global-media-settings').not('[data-media*="'+colorOption1+'"], [data-media*="'+colorOption2+'"], [data-media*="'+colorOption3+'"], [data-media*="'+colorOption4+'"], [data-media*="'+colorOption5+'"]').hide();          
          }
      setTimeout(function(){
        if($(document).find('[data-gallary-thumb-slider] li').length < 7 ) {
          $(document).find('[data-gallary-thumb-slider]').addClass('fixedPosition');
        }
        $('[data-gallary-featured-slider]').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          asNavFor: '[data-gallary-thumb-slider]',
          responsive: [
            {
              breakpoint: 749,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
        $('[data-gallary-thumb-slider]').slick({
          infinite: false,
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: '[data-gallary-featured-slider]',
          dots: false,
          focusOnSelect: true,
          vertical: false,
          arrows: false
        });
        $('[data-product-media-gallary-wrapper]').removeClass('enable-loader');



        // productModalOpener(dataurl, selectedColor)
      },300);

    },
    error: function(xhr){
      console.log(xhr)
    }
  })
}

// quick view image gallery

function __updateGalleryQuickView(selectedColor, pHandle){


  // alert('insert function');
  
  // $(document).find('product-modal#ProductModal-main-product-gallary img.global-media-settings[data-media]').show();
  // console.log("SelectedColor==>",selectedColor)
  // console.log("pHandle==>",pHandle)
  
  if(selectedColor.indexOf(' ') > -1){
    var colorOption1 = selectedColor.replace(' ', '-').replaceAll('/', '').toLowerCase(); //console.log(colorOption1)
    var colorOption2 = selectedColor.replace(' ', '_').replaceAll('/', '').toLowerCase(); //console.log(colorOption2)
    var colorOption3 = selectedColor.replace(' ', '').replaceAll('/', '').toLowerCase();// console.log(colorOption2)
  } else {
    var colorOption1 = selectedColor.replaceAll('/', '').toLowerCase(); console.log(colorOption1) 
  }
  
  // dataurl = $('body').data('handle');
  $.ajax({
    url: '/products/'+pHandle+'?view=imggalleryquickview',
    method: 'GET',
    success: function(res){
      if($(document).find('#common-main-quickview-layout.show-quickview:visible').length > 0 ){
        $(document).find('#common-main-quickview-layout #MediaGallery-main-quickview').remove();
      }
      $('#common-main-quickview-layout [data-media-quickview-drawer]').append(res);         
          $(document).find('#common-main-quickview-layout .product__media-item').not('[data-media*="'+colorOption1+'"], [data-media*="'+colorOption2+'"], [data-media*="'+colorOption3+'"]').remove();          
      setTimeout(function(){
        $('#common-main-quickview-layout .quickviewSlider').slick({
          infinite: false,
          adaptedHeight: false,
          arrows:true,
          dots: false
        });
        $(document).find('#common-main-quickview-layout [data-media-quickview-drawer]').removeClass('enable-loader');
      },300);

    },
    error: function(xhr){
      console.log(xhr)
    }
  })
}


// SizeChart Modal
$(document).on('click', '[data-size-chart-button-toggle]', function(){
  let getUrl = $(this).data('handle');

  $.ajax({
    url: '/pages/'+getUrl+'?view=sizechart',
    method: 'GET',
    success: function(res){
     $('.size-chart-modal-info').html(res);
     $('.size-chart-modal-overlay, .size-chart-modal-content').fadeIn();
    },
    error: function(xhr){
      console.log(xhr)
    }
  })
})

// hide size Chart modal
$(document).on('click', '.close-size-chart-modal, .size-chart-modal-overlay', function(){
  $('.size-chart-modal-overlay, .size-chart-modal-content').hide();
  $('.size-chart-modal-info').html('');
})


$(document).on('click', '[data-disclosure-toggle]', function(){
  $('[data-disclosure-list]').toggleClass('visible-disclosure-list')
})


// $(document).on('click',  '.spr-summary-starrating[data-product-id]', function(){
//   console.log('hiiiit');
//   $('.product__accordion').find('details[data-id="product-main-review-block"]').attr('open', '');
//   $('.product__accordion').find('details[data-id="product-main-review-block"] summary').attr('aria-expanded', 'true');
//   $('html, body').animate({
//     scrollTop: $('details[data-id="product-main-review-block"]').offset().top - 100
// }, 1000);
// });
// $(document).mouseup(function(e) {
//   // if($('[data-disclosure-list]').is(':visible')){
//     var container = $(".prod-quickview-container");

//     // if the target of the click isn't the container nor a descendant of the container
//     if (!container.is(e.target) && container.has(e.target).length === 0) 
//     {
//         // container.hide();
//         // $('#common-main-quickview-layout').hide()
//         if($('#common-main-quickview-layout:visible').length > 0){
//           $('[data-close-quickview-drawer]').trigger('click');
//         }
        
//     }

//   // }
// });

// $('.announcement-bar__message_slider').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: false,
//   autoplaySpeed: 2000,
//   arrows: true,
//   variableWidth: false,
//   // fade: true,
//   // cssEase: 'linear',
//   // lazyLoad: 'ondemand',
// });

//Global slick slider settings
if($(document).find('[data-slickslider]').length > 0){
  $('[data-slickslider]').each(function(){
    let sliderid = $(this).attr('id');
    let sliderAutoplay = $(this).attr('data-autoplay');
    let slideToShowDesktop = Number($(this).attr('data-item-desktop'));
    let slideToShowMobile = Number($(this).attr('data-item-mobile'));
    enableSlickSlider(sliderid, slideToShowDesktop, slideToShowMobile, sliderAutoplay)
  });
}

if($(document).find('#artilce-multi-product-list').length > 0){
  $('.featured__collection_wrapper[data-id]').each(function(){
    let targetId = '#'+$(this).attr('data-id');
    let targetItemLen = $(this).find('li.grid__item').length;
    console.log('List Item Length ==>', $(this).find('li.grid__item').length)
    if($(this).find('li.grid__item').length > 0){
     let detachItem = $(this).detach();
     $(document).find(targetId).append(detachItem); 
      // setTimeout(function(){
        $(document).find(targetId).attr('data-items', targetItemLen);
        if(targetItemLen < 5 ) {
          $(document).find(targetId).addClass('remove-desktop-dots')
        }
       let sliderid = $(document).find(targetId).find('[data-productlist-slickslider]').attr('id');
       let sliderAutoplay = $(document).find(targetId).find('[data-productlist-slickslider]').attr('data-autoplay');
       let slideToShowDesktop = Number($(document).find(targetId).find('[data-productlist-slickslider]').attr('data-item-desktop'));
       let slideToShowMobile = Number($(document).find(targetId).find('[data-productlist-slickslider]').attr('data-item-mobile'));
       enableSlickSlider(sliderid, slideToShowDesktop, slideToShowMobile, sliderAutoplay)  
      //  },500)
    }
    
  });
}



// header search toogle 
$('#header-search-toggle-button').on('click', function(){
   $('details-modal.header__search').toggleClass('header__search--visible');
});

$(document).mouseup(function(e) 
{
    var container = $("details-modal.header__search");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.removeClass('header__search--visible');
    }
});

// Search Template show sections if result 0 data-template="search"
if($('body').attr('data-template') == 'search'){
  setTimeout(function(){
    let resultCount = Number($('.boost-pfs-search-total-result strong').text()); console.log('Search Result Count==>', resultCount)
  if(resultCount == 0){
    $('body').addClass('search-result-zero');
  } else {
    $('body').removeClass('search-result-zero');
  }
  },1000);
}

    $(document).on('click', '.search-icon-mobile', function(){
      $(document).find('input.search__input.field__input.boost-pfs-search-box').addClass('red').focus();    
    })



   if($('html').attr('data-url') == '/collections/last-chance' && window.innerWidth < 768){
    var checkBoostLoaded = setInterval(function(){
      if($(document).find('.boost-pfs-filter-option-content-inner ul.boost-pfs-filter-option-item-list').length > 0 ){
        var getFilterOptionList = $(document).find('.boost-pfs-filter-option-content-inner').html(); console.log('filterhtml', getFilterOptionList);
        $(document).find('.boost-pfs-filter-toolbar-top-mobile').append(`<div class="sandbox-filterlist">${getFilterOptionList}</div>`);
        clearInterval(checkBoostLoaded);
      }
    });      
   } 

   $(document).on('click', '.sandbox-filterlist .boost-pfs-filter-option-item', function(){
    if($('html').attr('data-url') == '/collections/last-chance' && window.innerWidth < 768){
      $(this).toggleClass('selected');
      var getVal = $(this).find('.boost-pfs-check-box').attr('aria-labelledby');
      $('.boost-pfs-filter-mobile-style2[data-is-mobile]').find('.boost-pfs-filter-option-item .boost-pfs-check-box[aria-labelledby="'+getVal+'"]').parent('button').trigger('click');
    }
   })

  

});

function productModalOpener(prodHandle, selectedColor){
  if(selectedColor.indexOf(' ') > -1){
    var colorOption1 = selectedColor.replace(' ', '-').replaceAll('/', '').toLowerCase(); console.log(colorOption1)
    var colorOption2 = selectedColor.replace(' ', '_').replaceAll('/', '').toLowerCase(); console.log(colorOption2)
    var colorOption3 = selectedColor.replace(' ', '').replaceAll('/', '').toLowerCase(); console.log(colorOption2)
  } else {
    var colorOption1 = selectedColor.replaceAll('/', '').toLowerCase(); console.log(colorOption1) 
  }
  $.ajax({
  url: '/products/'+dataurl+'?view=imagegallerymodal',
  method: 'GET',
  success: function(res){
    if($(document).find('#shopify-section-main-product-gallary').length > 0 ){
      $(document).find('product-modal#ProductModal-main-product-gallary').remove();
    }
    $('body').append(res);        
        $(document).find('product-modal#ProductModal-main-product-gallary img.global-media-settings').not('[src*="'+colorOption1+'"], [src*="'+colorOption2+'"], [src*="'+colorOption3+'"]').remove();          

  },
  error: function(xhr){
    console.log(xhr)
  }
})
}


function updateCartPromo(cart){
  console.log("CART=====>",cart);
  $('.announcement-bar__message_slider .announcement-bar__message').each(function(){
      let totalPrice = 0;
    if($(this).find('[data-promoamount]').length > 0){
      let minAmnt = Number($(this).find('[data-id="cartpromoamnt"]').attr('data-promoamount'));
      for(var i=0; i<cart.items.length; i++){
          if(cart.items[i].vendor == 'SWIX HARDGOODS'){
            console.log(i);
            totalPrice += cart.items[i].original_line_price
          }
        
          // console.log('Each Item Type', cart.items[i].product_type );
      }
      console.log('TotalAmount', totalPrice );
      // let totalPrice = Number(cart.total_price); console.log('TotalPrice=>', totalPrice);
      let discountRemainingAmnt = Number((minAmnt-totalPrice)/100); console.log('discountRemainingAmnt=>', discountRemainingAmnt);
      $(this).find('[data-remainamount]').text('$'+discountRemainingAmnt);
      if(discountRemainingAmnt <= 0){
        $(this).find('[data-remainamount]').text('$0');
      }
    }        
  });

  // Get all the <li> elements in the container
  const listItems = document.querySelectorAll('#Slider-template--cart_recommendation .grid__item');

  // Create a Set to track unique data-ids
  const seenIds = new Set();

  // Loop through the list items and remove duplicates
  listItems.forEach(item => {
    const dataId = item.getAttribute('data-id'); // Get the data-id attribute value
    if (seenIds.has(dataId)) {
      item.remove(); // Remove the duplicate <li> element
    } else {
      seenIds.add(dataId); // Add the unique data-id to the Set
    }
  });
}

function printdiv(elem) {
  var header_str = '<html><head><title>' + document.title  + '</title></head><body>';
  var footer_str = '</body></html>';
  var new_str = document.getElementById(elem).innerHTML;
  var old_str = document.body.innerHTML;
  document.body.innerHTML = header_str + new_str + footer_str;
  window.print();
  document.body.innerHTML = old_str;
  return false;
}

function enableSlickSlider(sliderid, slideToShowDesktop, slideToShowMobile, sliderAutoplay){  
  $('#'+sliderid).slick({
  slidesToShow: slideToShowDesktop,
  slidesToScroll: slideToShowDesktop,
  autoplay: sliderAutoplay == "true" ? true : false, 
  infinite: sliderAutoplay == "true" ? true : false,
  arrows: false,
  dots: true,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: slideToShowMobile,
        slidesToScroll: slideToShowMobile,        
        arrows: false
      }
    }
    
  ]
});
}

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  var header = document.getElementById("shopify-section-header");
  if (window.pageYOffset > 40) {
      header.classList.add("sticky");
  } else {
      header.classList.remove("sticky");
  }
}

function openReviewAccordion() {
  var checkNewReviewCTA = setInterval(function(){
    console.log('0');
    if($(document).find('.jdgm-preview-badge').length > 0){       
     $('.product__accordion').find('details[data-id="product-main-review-block"]').attr('open', '');
     $('.product__accordion').find('details[data-id="product-main-review-block"] summary').attr('aria-expanded', 'true');
     $('html, body').animate({
       scrollTop: $('details[data-id="product-main-review-block"]').offset().top - 100
   }, 1000);                    
      clearInterval(checkNewReviewCTA);
    }  
  },10); 
}

function updateCartRecommendation(){  
  // Get all the <li> elements in the container
  const listItems = document.querySelectorAll('#Slider-template--cart_recommendation .grid__item');

  // Create a Set to track unique data-ids
  const seenIds = new Set();

  // Loop through the list items and remove duplicates
  listItems.forEach(item => {
    const dataId = item.getAttribute('data-id'); // Get the data-id attribute value
    if (seenIds.has(dataId)) {
      item.remove(); // Remove the duplicate <li> element
    } else {
      seenIds.add(dataId); // Add the unique data-id to the Set
    }
  });
}